import XLSX from 'sheetjs-style'
export const exportToExcel = (tableData: any, fileName: string) => {

   
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet charset=utf-8'
    // const fileExtension = '.xlsx'
    const ws = XLSX?.utils?.json_to_sheet(tableData)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    const link = document.createElement('a')
    // const fileName = `Questions_${Math.round(new Date().getTime() / 1000)}.xlsx`
    link.setAttribute('download', fileName)
    link.href = URL.createObjectURL(new Blob([data]))
    document.body.appendChild(link)
    link.click()
    link.remove()
}